import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveSubmenuComponent from './js/live-submenu.component';

ComponentsFactory.getInstance().define('live-submenu', LiveSubmenuComponent);
